<template>
  <v-dialog v-model="datetimeDialog" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedValue"
        readonly
        :required="required"
        :rules="required ? requiredRule : []"
        :label="label"
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        clearable
        @click:clear="updateDateTime('clear')"
      ></v-text-field>
    </template>
    <v-card class="t-datetime-picker white">
      <v-toolbar height="36" color="primary" dark flat>
        <v-tabs v-model="dateTimeTab" grow height="36">
          <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab href="#date">
            <v-icon>mdi-calendar</v-icon>
          </v-tab>
          <v-tab href="#time">
            <v-icon>mdi-clock</v-icon>
          </v-tab>
          <v-btn depressed text class="rounded-0" @click="closeDialog">
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="dateTimeTab">
        <v-tab-item value="date">
          <v-date-picker
            v-model="date"
            @change="updateDateTime"
            class="rounded-0"
            @input="dateTimeTab = 'time'"
            full-width
          >
          </v-date-picker>
        </v-tab-item>
        <v-tab-item value="time">
          <v-time-picker
            :key="dateTimeTab"
            v-model="time"
            format="24hr"
            class="rounded-0"
            full-width
            @change="updateDateTime"
          >
          </v-time-picker>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Publish Date",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    datetimeDialog: false,
    dateTimeTab: "date",
    date: "",
    time: "",

    requiredRule: [(v) => !!v || "This field is required"],
  }),
  computed: {
    formattedValue() {
      return this.value ? new Date(this.value).toLocaleString() : "";
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.date = newVal.substring(0, 10);
        this.time = new Date(new Date(newVal).getTime() + 2 * 60 * 60 * 1000)
          .toISOString()
          .substring(11, 16);
      } else {
        this.date = "";
        this.time = "";
      }
    },
  },
  methods: {
    updateDateTime(action) {
      if (action === "clear") {
        this.date = null;
        this.time = null;
        this.$emit("input", null);
      } else if (this.date && this.time) {
        const dt = new Date(
          new Date(this.date + "T" + this.time + ":00Z").getTime() -
            2 * 60 * 60 * 1000,
        ).toISOString();
        this.$emit("input", dt);
      } else {
        this.$emit("input", null);
      }
    },
    closeDialog() {
      this.datetimeDialog = false;
      this.dateTimeTab = "date";
    },
  },
};
</script>
